import type { IApplicationState } from 'shared/types/redux';

export const selectCPDDraftSource = (state: IApplicationState) => state.cpd.cpdDraftSource;
